<div [ngStyle]="{ 'display' : coordinatePointsController.active? 'block' : 'none'}" [ngClass]="tabsService.minimizeScreenMode ? 'bottom-menu minimized' : ''">
  <form autocomplete="off"  id="ngForm" name="ngForm" #ngForm="ngForm" class="active" [ngClass]="[tabsService.fullScreenMode ? 'fullscreen' : '']" data-tab="1" id="coordindatePointsForm">
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Coordinate Point Description</h4><span> </span>
        </div>

    <div class="input-fields">
      <div>
        <label for="">Identification</label>
        <input required maxlength=5 [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.coordpointid"
          type="text" name="coordpointid" id="coordpointid" #coordinatePointId="ngModel" alphaNumeric/>
          <span class="error" *ngIf=" (coordinatePointId.dirty || coordinatePointId.touched)
          && coordinatePointId.errors?.nonAlphaNumeric">
            Only alphanumeric characters, hyphens and underscores are allowed.
          </span>
        </div>

      <div>
        <label for="">Name</label>
        <input required [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.name"
         type="text" id="name" name="name" #name='ngModel' alphaNumeric/>
         <span class="error" *ngIf=" (name.dirty || name.touched)
            && name.errors?.nonAlphaNumeric">
              Only alphanumeric characters, hyphens and underscores are allowed.
            </span>
      </div>
    </div>

    <div class="dropdown-fields">
      <div>
        <label for="">Type</label>
        <select required [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.type" name="coordinatePointType"
          id="coordinatepointtype" #coordinatePointType='ngModel'>
          <option value="WAYPOINT">WAYPOINT</option>
          <option value="ARP_CIVIL">ARP_CIVIL</option>
          <option value="ARP_MILITAR">ARP Military</option>
          <option value="RWY_THR">RWY THR</option>
          <option value="AIRSPACE_BOUNDARY_VERTEX">Airspace Bounday Vertex</option>
          <option value="ARP_MIXED">ARP Mixed</option>
          <option value="FIX_POINT">Fix Point</option>
        </select>
      </div>
    </div>

      </div>
      <div class="fields__block__section">
        <div class="title">
          <h4>Position</h4><span> </span>
        </div>
        <div class="input-fields">
          <div *ngIf="coordinatePointsController.azimuthAndDistance"><label for="">Azimuth</label><input style="width: 60% !important; margin-right: 5px;"  [(ngModel)]="this.coordinatePointsController.azimuth"
            type="number" name="azimuth" id="azimuth" required="true" (ngModelChange)="isValueValid('Azimuth', this.azimuth)"/><span>[º]</span>
            <span class="error" *ngIf="!coordinatePointsController.azimuthValid">
              The Azimuth value should be defined between 0 and 360 degrees.
            </span></div>
          <div *ngIf="coordinatePointsController.azimuthAndDistance"><label for="">Distance</label><input style="width: 60% !important; margin-right: 5px;"  [(ngModel)]="this.coordinatePointsController.distance"
            type="number" name="distance" id="distance" required="true" (ngModelChange)="isValueValid('Distance', this.distance)"/><span>[m]</span>
            <span class="error" *ngIf="!coordinatePointsController.distanceValid">
              The Distance value should be defined between 0 and 3.4028235E38 meters.
            </span></div>
          <div><label for="">Latitude</label>
            <div class="coordenates">
              <div>
                <select name="latCardinal" [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.cardinal"
              (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.latitude = coordinatePointsController.selectedCoordinatePoint.latLonDms.toLat()"
              style="width: auto;" [disabled]="coordinatePointsController.azimuthAndDistance? true : false">
                <option value="N">N</option>
                <option value="S">S</option>
              </select>
              <input type="number"
              [disabled]="coordinatePointsController.azimuthAndDistance? true : false"
              id="latDegrees" name="latDegrees" required
              [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.degrees"
              (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.latitude = coordinatePointsController.selectedCoordinatePoint.latLonDms.toLat();isValueValid('lat_degrees', coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.degrees)"
              style="width: 16%;" /><span>º</span>
              <input required [disabled]="coordinatePointsController.azimuthAndDistance? true : false" type="number" id="latMinutes" name="latMinutes"
              [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.minutes"
              (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.latitude = coordinatePointsController.selectedCoordinatePoint.latLonDms.toLat();isValueValid('lat_minutes', coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.minutes)"
                style="width: 16%;" /><span>´</span>
              <input required [disabled]="coordinatePointsController.azimuthAndDistance? true : false" type="number" id="latSeconds" name="latSeconds"
                [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.seconds"
                (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.latitude = coordinatePointsController.selectedCoordinatePoint.latLonDms.toLat();isValueValid('lat_seconds', coordinatePointsController.selectedCoordinatePoint.latLonDms.latitude.seconds)"
                style="width: 16%;" /><span>´´</span>
              </div>
              <br />
              <input [disabled]="coordinatePointsController.azimuthAndDistance? true : false" [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.latitude"
                (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.latLonDms.fromLat(coordinatePointsController.selectedCoordinatePoint.latitude);isValueValid('latitude', coordinatePointsController.selectedCoordinatePoint.latitude)"
                type="number" style="width: 65.5%; margin-top: 5px; margin-bottom: 5px;"
                id="latitude" name="latitude" #latitude='ngModel' />
                <span class="error" *ngIf="!coordinatePointsController.latitudeValid">
                  The Latitude value must be an integer number defined between -90º and 90º.
                </span>
                <span class="error" *ngIf="!coordinatePointsController.lat_degreesValid">
                  The Degrees value must be an integer number defined between 0º and 90º.
                </span>
                <span class="error" *ngIf="!coordinatePointsController.lat_minutesValid">
                  The Minutes value must be an integer number defined between 0 and 59 minutes.
                </span>
                <span class="error" *ngIf="!coordinatePointsController.lat_secondsValid">
                  The Seconds value must be defined between 0 and 59.99.
                </span>
              </div>
          </div>
          <div><label for="">Longitude</label>
            <div class="coordenates">
              <div>
                <select [disabled]="coordinatePointsController.azimuthAndDistance? true : false" name="lonCardinal" [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.cardinal"
              (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.longitude = coordinatePointsController.selectedCoordinatePoint.latLonDms.toLon()"
                style="width: auto;">
                <option value="E">E</option>
                <option value="W">W</option>
              </select>
              <input required [disabled]="coordinatePointsController.azimuthAndDistance? true : false" type="number" id="lonDegrees" name="lonDegrees"
              [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.degrees"
              (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.longitude = coordinatePointsController.selectedCoordinatePoint.latLonDms.toLon();isValueValid('lon_degrees', coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.degrees)"
                style="width: 16%;" /><span>º</span>
              <input required [disabled]="coordinatePointsController.azimuthAndDistance? true : false" type="number" id="lonMinutes" name="lonMinutes"
                [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.minutes"
                (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.longitude = coordinatePointsController.selectedCoordinatePoint.latLonDms.toLon();isValueValid('lon_minutes', coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.minutes)"
                style="width: 16%;" /><span>´</span>
              <input required [disabled]="coordinatePointsController.azimuthAndDistance? true : false" type="number" id="lonSeconds" name="lonSeconds"
                [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.seconds"
                (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.longitude = coordinatePointsController.selectedCoordinatePoint.latLonDms.toLon();isValueValid('lon_seconds', coordinatePointsController.selectedCoordinatePoint.latLonDms.longitude.seconds)"
                style="width: 16%;" /><span>´´</span>
              </div>
              <br /><input [disabled]="coordinatePointsController.azimuthAndDistance? true : false"
                [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.longitude"
                (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.latLonDms.fromLon(coordinatePointsController.selectedCoordinatePoint.longitude);isValueValid('longitude', coordinatePointsController.selectedCoordinatePoint.longitude)"
                type="number" style="width: 65.5%; margin-top: 5px;"
                id="longitude" name="longitude" required #longitude='ngModel'/><span></span>
                <span class="error" *ngIf="!coordinatePointsController.longitudeValid">
                  The Longitude value must be an integer number defined between -180º and 180º.
                </span>
                <span class="error" *ngIf="!coordinatePointsController.lon_degreesValid">
                  The Degrees value must be an integer number defined between 0º and 180º.
                </span>
                <span class="error" *ngIf="!coordinatePointsController.lon_minutesValid">
                  The Minutes value must be an integer number defined between 0 and 59 minutes.
                </span>
                <span class="error" *ngIf="!coordinatePointsController.lon_secondsValid">
                  The Seconds value must be defined between 0 and 59.99.
                </span></div>
          </div>

        </div>
      </div>
    </div>
    <div class="fields__block">
      <div class="fields__block__section">
        <div class="title">
          <h4>Altitude</h4><span> </span>
        </div>
        <div class="input-fields">
          <div><label for="">Minimum Altitude</label>
            <div class="coordenates"><input [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.minaltitude"
              (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.minaltitudeMeters=pointsController.convertToMeters($event);isValueValid('Minimum_Altitude', coordinatePointsController.selectedCoordinatePoint.minaltitude)"
              type="number" style="width: 30%;" id="minaltitude" name="minaltitude" /><span>[ft]</span><input id="minaltitudeMeters" name="minaltitudenMeters"
                [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.minaltitudeMeters"
                (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.minaltitude=pointsController.convertToFeet($event)"
                type="number" style="width: 30%;" /><span>[m]</span>
                <span class="error" *ngIf="!coordinatePointsController.minAltitudeValid">
                  The Minimum Altitude value should be defined between 0 and 60000 ft.
                </span></div>
          </div>

          <div><label for="">Maximum Altitude</label>
            <div class="coordenates"><input [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.maxaltitude"
              (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.maxaltitudeMeters=pointsController.convertToMeters($event);isValueValid('Maximum_Altitude', coordinatePointsController.selectedCoordinatePoint.maxaltitude)" type="number" style="width: 30%;"
                id="maxaltitude" name="maxaltitude" /><span>[ft]</span><input id="maxaltitudeMeters" name="maxaltitudenMeters"
                [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.maxaltitudeMeters"
                (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.maxaltitude=pointsController.convertToFeet($event)" type="number" style="width: 30%;" /><span>[m]</span>
                <span class="error" *ngIf="!coordinatePointsController.maxAltitudeValid">
                  The Maximum Altitude value should be defined between 0 and 60000 ft.
                </span></div>
          </div>

          <div><label for="">Nominal Altitude</label>
            <div class="coordenates"><input [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.nominalaltitude"
              (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.nominalaltitudeMeters=pointsController.convertToMeters($event)" type="number" style="width: 30%;"
                id="nominalaltitude" name="nominalaltitude" disabled="true" /><span>[ft]</span><input id="nominalaltitudeMeters" name="nominalaltitudeMeters"
                [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.nominalaltitudeMeters"
                disabled="true"
                (ngModelChange)="coordinatePointsController.selectedCoordinatePoint.nominalaltitude=pointsController.convertToFeet($event)" type="number" style="width: 30%;" /><span>[m]</span></div>
          </div>
          <div style="margin-top:10px;">
            <div class="" style="width: auto;">
              <input [(ngModel)]="coordinatePointsController.selectedCoordinatePoint.notupdate"
            type="checkbox" id="infoupdate" name="infoupdate"/>
            <label for="" style="width: auto;">Allow Update from EAD</label>
            </div>
            <div style="margin-left: 10%;">
                <input
                  [(ngModel)]="published"
                  type="checkbox"
                  id="published"
                  name="published"
                />
                <label for="" style="width: auto;">Published</label>
              </div>
          </div>

        </div>
      </div>
    </div>
    <div class="fields__btn">
      <button type="submit" [ngClass]="ngForm.form.valid && projectService.activeProject?.editable? 'blue' : 'gray'" (click)="saveCoordinatePointValidation(); " [disabled]="!ngForm.form.valid || !projectService.activeProject?.editable">Save</button>
      <a class="gray" href="#" type="reset" value="Cancel" (click)="tabsService.closeTab()">Cancel</a>
    </div>

  </form>
</div>
